module.exports = __webpack_public_path__ + "static/media/hailstorm.f585ea96.png";